import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SmartintegService } from '../../../../services/smartinteg.service';
import { ToastService } from '../../../../services/toast.service';
import { mensagemErroApi } from '../../../../utils/mensagem-erro-api';
import { Sistema } from '../../../../types/smartinteg';

@Component({
  selector: 'app-processo-form',
  templateUrl: './processo-form.component.html',
  styleUrls: ['./processo-form.component.css']
})
export class ProcessoFormComponent implements OnInit {

  form!: FormGroup;
  loading: boolean = false;
  isEditMode: boolean = false;
  processoId?: string;

  sistemas: Sistema[] = [];
  carregandoSistemas: boolean = true;

  constructor(
    private fb: FormBuilder,
    private smartintegService: SmartintegService,
    private toastService: ToastService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.inicializarFormulario();
    this.carregarSistemas();
    this.verificarModoEdicao();
  }

  inicializarFormulario(): void {
    this.form = this.fb.group({
      nome: ['', [Validators.required, Validators.minLength(3)]],
      descricao: ['', Validators.required],
      // O backend recusa processo sem sistema ("Sistema é obrigatório informar")
      sistemaId: [null, Validators.required]
    });
  }

  carregarSistemas(): void {
    this.carregandoSistemas = true;
    this.smartintegService.listarSistemas().subscribe({
      next: (data) => {
        this.sistemas = data;
        this.carregandoSistemas = false;
      },
      error: (error) => {
        this.toastService.erro('Erro', 'Erro ao carregar sistemas: ' + mensagemErroApi(error));
        this.carregandoSistemas = false;
      }
    });
  }

  verificarModoEdicao(): void {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.isEditMode = true;
        this.processoId = params['id'];
        if (this.processoId) {
          this.carregarProcesso(this.processoId);
        }
      }
    });
  }

  carregarProcesso(id: string): void {
    this.loading = true;
    this.smartintegService.buscarProcesso(id).subscribe({
      next: (processo) => {
        this.form.patchValue({
          nome: processo.nome,
          descricao: processo.descricao,
          sistemaId: processo.sistemaId
        });
        this.loading = false;
      },
      error: (error) => {
        this.toastService.erro('Erro', 'Erro ao carregar processo: ' + mensagemErroApi(error));
        this.loading = false;
        this.voltar();
      }
    });
  }

  salvar(): void {
    if (this.form.invalid) {
      this.toastService.alerta('Atenção', 'Preencha todos os campos obrigatórios');
      this.marcarCamposComoTocados();
      return;
    }

    this.loading = true;
    const processoData = { ...this.form.value, id: this.processoId };

    const action = this.isEditMode
      ? this.smartintegService.atualizarProcesso(processoData)
      : this.smartintegService.criarProcesso(processoData);

    const message = this.isEditMode ? 'atualizado' : 'criado';

    action.subscribe({
      next: (processo) => {
        this.toastService.sucesso('Sucesso', `Processo ${message} com sucesso`);
        this.loading = false;
        // POST /processos devolve o processo criado: segue direto para configurar o fluxo
        if (!this.isEditMode && processo?.id) {
          this.router.navigate(['/smartinteg/processos', processo.id, 'fluxo']);
        } else {
          this.voltar();
        }
      },
      error: (error) => {
        this.toastService.erro('Erro', `Erro ao ${this.isEditMode ? 'atualizar' : 'criar'} processo: ` + mensagemErroApi(error));
        this.loading = false;
      }
    });
  }

  marcarCamposComoTocados(): void {
    Object.values(this.form.controls).forEach(control => control.markAsTouched());
  }

  campoInvalido(campo: string): boolean {
    const control = this.form.get(campo);
    return !!(control && control.invalid && control.touched);
  }

  irParaSistemas(): void {
    this.router.navigate(['/smartinteg/sistemas']);
  }

  voltar(): void {
    this.router.navigate(['/smartinteg/processos']);
  }
}
